<app-spinner-container [isLoading]="ondelete">
    <table
            (matSortChange)="onSortChange($event)"
            [dataSource]="dataSource"
            mat-table
            matSort

            style="width: 100%"
    >
        <ng-container *ngFor="let column of readColumns" [matColumnDef]="column">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>
                {{ labels[column] | translate }}
            </th>
            <td *matCellDef="let type" mat-cell translate>
                {{ type[column] | typedValue | async | translate}}
            </td>
        </ng-container>
        <ng-container matColumnDef="action">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let consultation" mat-cell>
                <div class="py-2 text-center">
                    <!-- <button (click)="renouveler()">Renouveler</button> -->
                    <div fxFlex="90" fxLayoutAlign="center center">
                        <a (click)="renouveler(consultation)" class=" st-butt-plusinfo text-wrap" mat-raised-button>
                            {{'Renouveler' | translate}}
                        </a>
                    </div>


                </div>

            </td>
        </ng-container>
        <tr *matHeaderRowDef="getlang()?displayedColumnsAR:displayedColumnsFR" mat-header-row></tr>
        <tr *matRowDef="let row; columns: getlang()?displayedColumnsAR:displayedColumnsFR" mat-row></tr>
    </table>
    <app-empty-list-container
            [list]="dataSource.data"
            [msg]="message"
            [withoutBorder]="true"
    ></app-empty-list-container>
</app-spinner-container>
<!-- <app-offer [offer]="offer"></app-offer> -->
